import React, { useEffect, useState } from 'react';
import './styles';
import { PHOTOSHOOT_TYPE_SERVICE } from '../../../../../../../utils/Config/Constants';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getFiltersProp } from '../../../../../../../redux/selectors/CurrentUserSelectors';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../../../components/PL/PLTable/TypeScriptHelpers';
import { PARTNER_PACKAGE_TABLE_TYPE } from '../../../../../../../components/PL/PLTable/config';
import { useLazyQuery } from 'react-apollo';
import { GET_FINANCE_SERVICES_WITH_QUERY } from '../../queries';
import { PLFILTER_TYPE_FINANCE } from '../../../../../../../components/PL/PLFilters/config';
import PLFilters from '../../../../../../../components/PL/PLFilters';
import PLTable from '../../../../../../../components/PL/PLTable/PLTable';
import * as strings from './strings';
import UILoadingPage from '../../../../../../../components/UI/UILoadingPage/UILoadingPage';
import AdminFinanceDownload from '../AdminFinanceDownload/AdminFinanceDownload';

export default function AdminFinancesPartners({}: AdminFinancesPartnersProps) {
	const QUERY_LIMIT = 10000;

	const [servicesInRange, setServicesInRange] = useState<ServiceType[]>();

	const filters = useSelector(getFiltersProp);
	const location = useLocation();

	let props = {
		filters,
		location
	};

	let baseVariables = {
		query: { orderInformation: { op_ne: null }, type: { op_eq: PHOTOSHOOT_TYPE_SERVICE } }
	};

	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, PARTNER_PACKAGE_TABLE_TYPE, props, baseVariables);
	const [getServicesWithOrderInformation, { data: servicesData }] = useLazyQuery(GET_FINANCE_SERVICES_WITH_QUERY, {
		variables
	});

	useEffect(() => {
		(async () => {
			await getServicesWithOrderInformation();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (servicesData) {
				const fetchedServices: ServiceType[] = servicesData['services'];
				setServicesInRange(
					fetchedServices.sort((a, b) => {
						return a.orderInformation?.price > b.orderInformation?.price ? 1 : -1;
					})
				);
			}
		})();
	}, [servicesData]);

	if (!servicesInRange) return <UILoadingPage />;

	const renderFinanceHeader = () => {
		return (
			<div className='adminFinancesPartners__header'>
				<PLFilters type={PLFILTER_TYPE_FINANCE} updateTable={getServicesWithOrderInformation} />
				<div className='adminFinancesPartners__header--item'>{strings.totalServices(servicesInRange.length)}</div>
				<AdminFinanceDownload name='partners.csv' json={servicesInRange} />
			</div>
		);
	};

	const renderTabContent = () => {
		return <PLTable type={PARTNER_PACKAGE_TABLE_TYPE} data={servicesInRange} limit={QUERY_LIMIT} updateTable={getServicesWithOrderInformation} />;
	};

	return (
		<div className='adminFinancesPartners'>
			{renderFinanceHeader()}
			<div className='adminFinancesPartners__content'>{renderTabContent()}</div>
		</div>
	);
}
